import React from 'react';
import styles from './SignupContainer.module.scss';
import { Row, Col } from 'antd';
import { SignupContainerEnums } from 'enums/SignupContainerEnums';

interface SignupContainerProps {
  children?: React.ReactNode;
}
const SignupContainer = ({ children }: SignupContainerProps) => {
  return (
    <div>
      <Row>
        <Col span={15} className={styles.imageContainer}>
          <div className={styles.contentContainer}>
            <div className={styles.headingContainer}>
              <h1>{SignupContainerEnums.HEADING_1}</h1>
              <h2>{SignupContainerEnums.SEPARATOR}</h2>
              <h1>{SignupContainerEnums.HEADING_2}</h1>
              <h2>{SignupContainerEnums.SEPARATOR}</h2>
              <h1>{SignupContainerEnums.HEADING_3}</h1>
            </div>
            <div className={styles.subheadingContainer}>
              <p>{SignupContainerEnums.SUBHEADING}</p>
            </div>
          </div>
        </Col>
        <Col span={9} className={styles.formContainer}>
          {children}
        </Col>
      </Row>
    </div>
  );
};

export default SignupContainer;
